"use client";

import React from "react";
import { Input } from "@/components/ui/input";
import { Calendar } from "lucide-react";
import type { SimpleFieldConfig } from "../../../types/index";

interface DateFilterInputProps {
  fieldId: string;
  fieldConfig: SimpleFieldConfig;
  currentFilter?: { type: string; value: any };
  addAdvancedFilter: (fieldId: string, filterType: string, value: any) => void;
}

export function DateFilterInput({
  fieldId,
  fieldConfig,
  currentFilter,
  addAdvancedFilter,
}: DateFilterInputProps) {
  return (
    <div className="space-y-2">
      <div className="flex items-center gap-2">
        <Calendar className="h-4 w-4 text-gray-400" />
        <Input
          type="date"
          placeholder="From"
          value={currentFilter?.value?.min || ""}
          onChange={(e) =>
            addAdvancedFilter(fieldId, "dateRange", {
              min: e.target.value,
              max: currentFilter?.value?.max,
            })
          }
          className="flex-1"
        />
      </div>
      <div className="flex items-center gap-2">
        <Calendar className="h-4 w-4 text-gray-400" />
        <Input
          type="date"
          placeholder="To"
          value={currentFilter?.value?.max || ""}
          onChange={(e) =>
            addAdvancedFilter(fieldId, "dateRange", {
              min: currentFilter?.value?.min,
              max: e.target.value,
            })
          }
          className="flex-1"
        />
      </div>
    </div>
  );
}
